<script setup>
import { defineProps } from 'vue';
import {formatDate, useTimeDifference} from '@/globals/utils/formatDate';

const props = defineProps({
  date: {
    type: [String, Date],
    required: true
  }
});

const humanReadableTime = useTimeDifference(props.date);
</script>

<template>
  <span class="text-sm text-gray-500" :title="formatDate(date,'DD/MM/YYYY HH:mm')">{{ humanReadableTime }}</span>
</template>
